
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Calendar, MapPin, Users } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
interface TripHeaderProps {
  onCreateTrip?: () => void;
  onJoinTrip?: () => void;
  tripCount?: number;
  upcomingTrips?: number;
}
const TripHeader: React.FC<TripHeaderProps> = ({
  onCreateTrip,
  onJoinTrip,
  tripCount = 0,
  upcomingTrips = 0
}) => {
  return <div className="space-y-4">
      <div className="flex flex-col">
        <h1 className="text-3xl font-bold mb-2 font-poppins">My Trips</h1>
        
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Card className="bg-gradient-to-br from-purple-light/30 to-slate-50 border-purple-DEFAULT/20">
          <CardContent className="flex items-center p-4">
            <div className="h-10 w-10 rounded-full bg-purple-light/30 flex items-center justify-center mr-3">
              <MapPin className="h-5 w-5 text-purple-secondary" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Trips</p>
              <p className="text-2xl font-semibold">{tripCount}</p>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-gradient-to-br from-purple-soft/30 to-slate-50 border-purple-soft/30">
          <CardContent className="flex items-center p-4">
            <div className="h-10 w-10 rounded-full bg-purple-soft/30 flex items-center justify-center mr-3">
              <Calendar className="h-5 w-5 text-purple-DEFAULT" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Upcoming</p>
              <p className="text-2xl font-semibold">{upcomingTrips}</p>
            </div>
          </CardContent>
        </Card>
      </div>

      {onCreateTrip && <div className="flex space-x-3">
          
          
          {onJoinTrip && <Button variant="outline" onClick={onJoinTrip} className="flex items-center">
              <Users className="h-4 w-4 mr-2" />
              Join Trip
            </Button>}
        </div>}
    </div>;
};
export default TripHeader;
